//import Vue from 'vue'
// Lib imports
import axios from 'axios'
import store from '@/store'

const axiosp = axios.create()
axiosp.interceptors.request.use(async(config) => {
    const user = await store.dispatch('getOidcUser');
    if (user) {
      const authToken = user.access_token;
      //store.commit('userAuthenticated', user)
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
        config.withCredentials = true;
      }
    } 
    return config;
  },
  () => {
    //What do you want to do when a call fails?
    console.log("call failed");
  })
  axiosp.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
    }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.log('interceptor unauthorized error', error.response)
    
    if(error.response.status === 401){
      store.dispatch("authenticate")
    } 
    /*else if(error.response.status===404){
      window.location.replace(process.env.VUE_APP_BASE_URL)
    } /*else if(error.response.status==400){
      window.location.replace(process.env.VUE_APP_BASE_URL)
    }
    /**/
    return Promise.reject(error);
  })

  export default axiosp